import { computed, observable, makeObservable } from 'mobx';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { AudioPayload } from '../AudioPayload/AudioPayload';
import { ContactPayload } from '../ContactPayload/ContactPayload';
import { FilePayload } from '../FilePayload/FilePayload';
import { ImagePayload } from '../ImagePayload/ImagePayload';
import { LocationPayload } from '../LocationPayload/LocationPayload';
import { Payload } from '../Payload';
import { TextPayload } from '../TextPayload/TextPayload';
import { VideoPayload } from '../VideoPayload/VideoPayload';

const MEDIA_TYPES = [PayloadType.Image, PayloadType.Video];

const PayloadClass = {
  [PayloadType.Image]: ImagePayload,
  [PayloadType.Video]: VideoPayload,
  [PayloadType.RichText]: TextPayload,
  [PayloadType.Contact]: ContactPayload,
  [PayloadType.AudioMessage]: AudioPayload,
  [PayloadType.File]: FilePayload,
  [PayloadType.Location]: LocationPayload,
};

export class ArticlePayload extends Payload {
  @observable payloads;
  title;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.Article });

    makeObservable(this);

    this.payloads = data.payloads
      .sort((a, b) => a.order - b.order)
      .map(({ id, order, payloadType, payload }) => ({
        id,
        order,
        payloadType,
        payload: new PayloadClass[payload.payloadType]({
          ...payload,
          message: {
            forward: null,
            repliedMessage: null,
            quote: null,
            hasError: false,
            setError() {
              this.hasError = true;
            },
          },
        }),
      }));

    this.title = data.title;
    this.userMentions = data.userMentions;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      title: this.title,
      userMentions: this.userMentions,

      payloads: this.payloads.map((payload, idx) => ({
        id: payload.id,
        payloadType: payload.payloadType,
        order: idx,
        payload: payload.payload.toJSON(),
      })),
    };
  }

  @computed
  get firstMediaPayload() {
    return this.payloads.find(({ payload }) => {
      return MEDIA_TYPES.includes(payload?.payloadType);
    });
  }

  @computed
  get firstTextPayload() {
    return this.payloads.find(({ payload }) => {
      return (
        payload.payloadType === PayloadType.RichText &&
        String(payload?.text || '').trim().length > 0
      );
    });
  }
}
